export default {
  googlePlayStoreLink: 'google-play-store-link',
}
